module.exports = __webpack_public_path__ + "2023124:cb48231cec1aa2d91890/img/Till-This-Day-Tile_no-spot.44aac0a.png";